// Utility per aprire una finestra di stampa badge ufficiale ANC (A6 portrait)
// CSS embedded sincronizzato con badge-officiale.css

const BADGE_CSS = `
@page { size: A6 portrait; margin: 0; }
* { box-sizing: border-box; }
html, body { margin: 0; padding: 0; }
body { font-family: 'Helvetica Neue', Arial, sans-serif; -webkit-print-color-adjust: exact; print-color-adjust: exact; background:#e5e5e5; }
.badge { position: relative; width: 105mm; height: 148mm; overflow: hidden; background-image: url('/anc-campo-gestione/badge_template.png'); background-size: 105mm 148mm; background-repeat: no-repeat; background-position: 0 0; page-break-after: always; margin: 6mm auto; box-shadow: 0 2mm 6mm rgba(0,0,0,0.25); }
.badge-name { position: absolute; top: 62mm; left: 3mm; right: 3mm; height: 14mm; display: flex; align-items: center; justify-content: center; color: #ffffff; font-size: 6.2mm; font-weight: 800; letter-spacing: 0.3mm; text-align: center; line-height: 1.05; text-shadow: 0 0.4mm 0.6mm rgba(0,0,0,0.35); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-transform: uppercase; }
.badge-name.long { font-size: 5mm; }
.badge-name.xlong { font-size: 4.2mm; }
.badge-role { position: absolute; top: 72mm; left: 3mm; right: 32mm; height: 12mm; display: flex; align-items: center; justify-content: center; color: #ffffff; font-size: 3.8mm; font-weight: 600; text-align: center; line-height: 1.1; text-shadow: 0 0.3mm 0.5mm rgba(0,0,0,0.3); overflow: hidden; }
.badge-qr { position: absolute; top: 95mm; right: 4mm; width: 28mm; height: 28mm; background: #ffffff; padding: 1mm; border-radius: 1mm; box-shadow: 0 0.3mm 0.6mm rgba(0,0,0,0.25); display:flex; align-items:center; justify-content:center; }
.badge-qr img { width: 100%; height: 100%; display: block; }
.badge-code { position: absolute; top: 126mm; right: 4mm; width: 26mm; text-align: center; color: #ffffff; font-size: 2.6mm; font-weight: 700; letter-spacing: 0.2mm; text-shadow: 0 0.3mm 0.4mm rgba(0,0,0,0.4); }
.toolbar { position: fixed; top: 8px; right: 8px; display: flex; gap: 8px; z-index: 9999; }
.toolbar button { padding: 8px 14px; border: 0; border-radius: 6px; cursor: pointer; font-weight: 600; }
.toolbar .print { background:#1d4ed8; color:#fff; }
.toolbar .close { background:#e5e7eb; color:#111; }
@media print { body { margin: 0; background:#fff; } .badge { margin:0; box-shadow:none; } .toolbar, .no-print { display: none !important; } }
`;

function nameClass(name) {
  const n = (name || '').trim();
  if (n.length > 24) return 'badge-name xlong';
  if (n.length > 18) return 'badge-name long';
  return 'badge-name';
}

function esc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function qrUrl(code) {
  if (!code) return '';
  return 'https://api.qrserver.com/v1/create-qr-code/?size=600x600&margin=0&data=' + encodeURIComponent(code);
}

export function openBadgePrintWindow(person) {
  const fullName = [person && person.nome, person && person.cognome].filter(Boolean).join(' ').trim() || (person && (person.full_name || person.name)) || 'VOLONTARIO';
  const role = (person && (person.ruolo || person.role || person.organizzazione || person.org || person.gruppo)) || '';
  const code = (person && (person.codice_qr || person.qr_code || person.codice || person.code)) || '';
  const qrSrc = qrUrl(code);

  const html = '<!DOCTYPE html>' +
    '<html lang="it"><head><meta charset="utf-8"><title>Badge ' + esc(fullName) + '</title>' +
    '<style>' + BADGE_CSS + '</style></head><body>' +
    '<div class="toolbar no-print">' +
      '<button class="print" onclick="window.print()">Stampa</button>' +
      '<button class="close" onclick="window.close()">Chiudi</button>' +
    '</div>' +
    '<div class="badge">' +
      '<div class="' + nameClass(fullName) + '">' + esc(fullName) + '</div>' +
      '<div class="badge-role">' + esc(role) + '</div>' +
      '<div class="badge-qr">' + (qrSrc ? '<img src="' + qrSrc + '" alt="QR">' : '') + '</div>' +
      '<div class="badge-code">' + esc(code) + '</div>' +
    '</div></body></html>';

  const w = window.open('', '_blank', 'width=520,height=760');
  if (!w) { alert('Abilita le finestre popup per stampare il badge.'); return; }
  w.document.open();
  w.document.write(html);
  w.document.close();
}


export function openBadgeBulkPrintWindow(persons) {
  const list = Array.isArray(persons) ? persons.filter(Boolean) : [];
  if (list.length === 0) { alert('Seleziona almeno un volontario.'); return; }
  const PAGE_CSS = `
@page { size: A4 portrait; margin: 0; }
* { box-sizing: border-box; }
html, body { margin: 0; padding: 0; background:#e5e5e5; font-family: 'Helvetica Neue', Arial, sans-serif; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
.toolbar { position: fixed; top: 8px; right: 8px; display:flex; gap:8px; z-index:9999; }
.toolbar button { padding: 8px 14px; border:0; border-radius:6px; cursor:pointer; font-weight:600; }
.toolbar .print { background:#1d4ed8; color:#fff; }
.toolbar .close { background:#e5e7eb; color:#111; }
.sheet { width:210mm; height:297mm; padding:0; margin:6mm auto; background:#fff; box-shadow:0 2mm 6mm rgba(0,0,0,0.25); display:grid; grid-template-columns: 105mm 105mm; grid-template-rows: 148.5mm 148.5mm; page-break-after: always; }
.sheet:last-child { page-break-after: auto; }
.cell { width:105mm; height:148.5mm; overflow:hidden; position:relative; }
.cell .badge { width:105mm; height:148mm; margin:0; box-shadow:none; page-break-after:auto; position:relative; background-image: url('/anc-campo-gestione/badge_template.png'); background-size: 105mm 148mm; background-repeat:no-repeat; background-position: 0 0; }
.badge-name { position:absolute; top:62mm; left:3mm; right:3mm; height:14mm; display:flex; align-items:center; justify-content:center; color:#fff; font-size:6.2mm; font-weight:800; letter-spacing:0.3mm; text-align:center; line-height:1.05; text-shadow:0 0.4mm 0.6mm rgba(0,0,0,0.35); white-space:nowrap; overflow:hidden; text-overflow:ellipsis; text-transform:uppercase; }
.badge-name.long { font-size:5mm; }
.badge-name.xlong { font-size:4.2mm; }
.badge-role { position:absolute; top:72mm; left:3mm; right:32mm; height:12mm; display:flex; align-items:center; justify-content:center; color:#fff; font-size:3.8mm; font-weight:600; text-align:center; line-height:1.1; text-shadow:0 0.3mm 0.5mm rgba(0,0,0,0.3); overflow:hidden; }
.badge-qr { position:absolute; top:95mm; right:4mm; width:28mm; height:28mm; background:#fff; padding:1mm; border-radius:1mm; box-shadow:0 0.3mm 0.6mm rgba(0,0,0,0.25); display:flex; align-items:center; justify-content:center; }
.badge-qr img { width:100%; height:100%; display:block; }
.badge-code { position:absolute; top:126mm; right:4mm; width:26mm; text-align:center; color:#fff; font-size:2.6mm; font-weight:700; letter-spacing:0.2mm; text-shadow:0 0.3mm 0.4mm rgba(0,0,0,0.4); }
@media print { body { margin:0; background:#fff; } .sheet { margin:0; box-shadow:none; } .toolbar, .no-print { display:none !important; } }
`;
  const renderBadge = (p) => {
    const fullName = ([p && p.nome, p && p.cognome].filter(Boolean).join(' ').trim() || (p && (p.full_name || p.name)) || 'VOLONTARIO');
    const role = (p && (p.ruolo || p.role || p.organizzazione || p.org || p.gruppo)) || '';
    const code = (p && (p.codice_qr || p.qr_code || p.codice || p.code || p.id)) || '';
    const qrSrc = qrUrl(code);
    return (
      '<div class="cell"><div class="badge">' +
        '<div class="' + nameClass(fullName) + '">' + esc(fullName) + '</div>' +
        '<div class="badge-role">' + esc(role) + '</div>' +
        '<div class="badge-qr">' + (qrSrc ? '<img src="' + qrSrc + '" alt="QR">' : '') + '</div>' +
        '<div class="badge-code">' + esc(code) + '</div>' +
      '</div></div>'
    );
  };
  // Build pages of 4 badges each
  let pages = '';
  for (let i = 0; i < list.length; i += 4) {
    const chunk = list.slice(i, i + 4);
    let cells = chunk.map(renderBadge).join('');
    // Fill empty cells to keep grid layout
    for (let j = chunk.length; j < 4; j++) cells += '<div class="cell"></div>';
    pages += '<div class="sheet">' + cells + '</div>';
  }
  const html = '<!DOCTYPE html>' +
    '<html lang="it"><head><meta charset="utf-8"><title>Stampa Badge Massiva (' + list.length + ')</title>' +
    '<style>' + PAGE_CSS + '</style></head><body>' +
    '<div class="toolbar no-print">' +
      '<button class="print" onclick="window.print()">Stampa ' + list.length + ' badge</button>' +
      '<button class="close" onclick="window.close()">Chiudi</button>' +
    '</div>' + pages +
    '</body></html>';
  const w = window.open('', '_blank', 'width=900,height=1100');
  if (!w) { alert('Abilita le finestre popup per stampare i badge.'); return; }
  w.document.open(); w.document.write(html); w.document.close();
}

export default { openBadgePrintWindow, openBadgeBulkPrintWindow };
